window.addEventListener('DOMContentLoaded', () => {
  initContactForm();
});
export function initContactForm() {
  window.addEventListener('UC_UI_INITIALIZED', () => {
    const captchaCookie = checkCaptchaCookieStatus();
    setByCookieStatus(captchaCookie);
    if (captchaCookie) initShadowRootCookieNoticeButtons();
  });
}
function checkCaptchaCookieStatus() {
  if (!window.UC_UI) return false;
  return window.UC_UI.getServicesBaseInfo().find(service => service.name === 'reCaptcha v3').consent.status === true;
}
function initShadowRootCookieNoticeButtons() {
  window.addEventListener('UC_UI_CMP_EVENT', function (e) {
    const types = ['ACCEPT_ALL', 'DENY_ALL', 'SAVE'];
    if (e.detail && types.includes(e.detail.type)) {
      setByCookieStatus(checkCaptchaCookieStatus());
    }
  });
}
function setByCookieStatus(active = false) {
  const form = document.querySelector('.c-contact-form');
  const warning = form?.querySelector('.form-warning');
  const sendButton = form?.querySelector('button[type="submit"]');
  const acceptButton = form?.querySelector('.accept-captcha-cookie');
  warning?.classList?.toggle('hidden', active);
  if (sendButton) sendButton.disabled = !active;
  if (!active) {
    acceptButton?.addEventListener('click', acceptCaptchaCookie);
  } else {
    acceptButton?.removeEventListener('click', acceptCaptchaCookie);
  }
}
function acceptCaptchaCookie() {
  window.UC_UI?.acceptService('cfADcn3E3')?.then(() => setByCookieStatus(true));
}